// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-card-gift-wrapper .order-card-gift {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order-card-gift-wrapper .order-card-gift .order-card-gift-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-small);
}
.order-card-gift-wrapper .order-card-gift .order-card-gift-info .item-image {
  width: 80px;
  height: 80px;
  border: 1px solid var(--color-neutral-light);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.order-card-gift-wrapper .order-card-gift .order-card-gift-info .item-image img {
  width: 60px;
  height: 60px;
  display: block;
  margin: 0 auto;
}
.order-card-gift-wrapper .order-card-gift .order-card-gift-info .item-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 20px;
}
.order-card-gift-wrapper .order-card-gift .order-shipping-gift {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.order-card-gift-wrapper .order-card-gift .order-shipping-gift .order-shipping-title {
  font-size: var(--font-paragraph);
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  color: var(--color-neutral-dark);
}
.order-card-gift-wrapper .order-card-gift .order-shipping-gift .order-shipping-date {
  font-size: var(--font-paragraph);
  line-height: 16px;
  letter-spacing: 0em;
  color: var(--color-neutral-dark);
}
.order-card-gift-wrapper .order-accordion {
  padding: var(--spacing-medium);
}
.order-card-gift-wrapper .order-accordion .accordion-header.accordion-default .accordion-label {
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 20px;
  text-justify: auto;
}
@media (max-width: 768px) {
  .order-card-gift-wrapper .order-card-gift {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: var(--spacing-small);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Orders/OrderCardGift/OrderCardGift.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAJA;EAOM,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;AAAN;AAVA;EAaQ,WAAA;EACA,YAAA;EACA,4CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAnBA;EAsBU,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAAV;AAzBA;EA8BQ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AAFR;AAjCA;EAwCM,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AAJN;AAvCA;EA8CQ,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAJR;AA9CA;EAqDQ,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAJR;AApDA;EA8DI,8BAAA;AAPJ;AAvDA;EAiEQ,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPR;AAYE;EAAA;IAEI,aAAA;IACA,2BAAA;IACA,uBAAA;IACA,sBAAA;IACA,yBAAA;EAVJ;AACF","sourcesContent":[".order-card-gift-wrapper {\n  .order-card-gift {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .order-card-gift-info {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: var(--spacing-small);\n\n      .item-image {\n        width: 80px;\n        height: 80px;\n        border: 1px solid var(--color-neutral-light);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 50%;\n\n        img {\n          width: 60px;\n          height: 60px;\n          display: block;\n          margin: 0 auto;\n        }\n      }\n\n      .item-info {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        font-size: var(--font-medium);\n        font-weight: 600;\n        line-height: 20px;\n      }\n    }\n\n    .order-shipping-gift {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n\n      .order-shipping-title {\n        font-size: var(--font-paragraph);\n        font-weight: 600;\n        line-height: 16px;\n        letter-spacing: 0em;\n        color: var(--color-neutral-dark);\n      }\n      .order-shipping-date {\n        font-size: var(--font-paragraph);\n        line-height: 16px;\n        letter-spacing: 0em;\n        color: var(--color-neutral-dark);\n      }\n    }\n  }\n\n  .order-accordion {\n    padding: var(--spacing-medium);\n    .accordion-header.accordion-default {\n      .accordion-label {\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        line-height: 20px;\n        text-justify: auto;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    .order-card-gift {\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n      flex-direction: column;\n      gap: var(--spacing-small);\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
